import { Box, Typography, useTheme } from '@mui/material';
import { tokens } from '../../../../../global/theme/tokens';

// One counter of the overview row: same tile as the invoice overview KPIs,
// plus a colored left edge for the status.
const OverviewStatCard = ({ icon, label, value, caption, color }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  return (
    <Box
      sx={{
        backgroundColor: colors.card,
        border: `1px solid ${colors.selected}`,
        borderLeft: `3px solid ${color}`,
        borderRadius: '10px',
        padding: 1.25,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.25,
        minWidth: 0,
        minHeight: 76,
      }}
    >
      <Box className="flex items-center gap-1 min-w-0" sx={{ color }}>
        {icon}
        <Typography
          variant="caption"
          noWrap
          sx={{
            fontSize: '0.7rem',
            textTransform: 'uppercase',
            letterSpacing: 0.4,
          }}
        >
          {label}
        </Typography>
      </Box>

      <Box className="flex items-baseline gap-2 min-w-0">
        <Typography variant="h6" sx={{ color, fontWeight: 600, lineHeight: 1.2 }}>
          {value}
        </Typography>
        <Typography
          noWrap
          sx={{ color: colors.text, opacity: 0.6, fontSize: '0.72rem' }}
        >
          {caption}
        </Typography>
      </Box>
    </Box>
  );
};

export default OverviewStatCard;
